export const formatValue = (
  input: string | number,
  decimals: number = 2,
): string => {
  const numericValue =
    typeof input === "string"
      ? parseFloat(input.replace(/[^\d.-]/g, ""))
      : input;

  if (isNaN(numericValue)) return "";

  return numericValue
    .toFixed(decimals) // Define o número de casas decimais
    .replace(".", ",") // Substitui ponto por vírgula
    .replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Adiciona separadores de milhares
};
